const CustomTableHeadColumn = ({ style, children, className = '', tabIndex, ariaControls, rowSpan, colSpan, ariaLabel, onClick, ...rest }) => {
    return (
        <th
            className={`sorting ${className}`}
            tabIndex={tabIndex ? tabIndex : 0}
            aria-controls={ariaControls}
            rowSpan={rowSpan ? rowSpan : 1}
            colSpan={colSpan ? colSpan : 1}
            aria-label={ariaLabel}
            style={style}
            onClick={onClick}
            {...rest}
        >
            {children}
        </th>
    )
}

export default CustomTableHeadColumn;